package com.tixforgigs.common.core.enums

const val CURRENCY_EUR = "€"

enum class CurrencyLegacy(val value: String) {
  EUR(CURRENCY_EUR),
  USD("$"),
  ;

  companion object {

    infix fun from(name: String): CurrencyLegacy? = CurrencyLegacy.entries.firstOrNull { it.name == name }
  }
}
